var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" "+_vm._s(_vm.title)+" "),_c('a-tooltip',{attrs:{"title":_vm.tooltip}},[_c('a-icon',{staticClass:"mrg-right-4",attrs:{"type":"info-circle"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }